<template>
  <div
    id="main"
    :style="{ '--nav-height': navHeight + 'px', '--sidebar-width': sidebarWidth + 'px' }"
  >
    <div v-if="$store.state.isLoggedIn" class="wrapper">
      <!-- <v-toolbar color="blue-grey" dark fixed app clipped-right>
          <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
          <v-toolbar-title>Toolbar</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>-->

      <app-header @onTrigger="drawer = !drawer" @resize="handleHeaderResize">
        <template slot="prepend">
          <slot name="prepend"></slot>
        </template>
        <template slot="append">
          <slot name="append"></slot>
        </template>
      </app-header>
      <v-navigation-drawer
        v-model="drawer"
        fixed
        dark
        app
        :class="{ menu: true, default: isDefaultTheme, primary: !isDefaultTheme }"
      >
        <v-layout v-if="!isTicket2agent">
          <v-flex>
            <v-btn v-if="showHomeBtn" fab flat dark small @click="onGoHome">
              <v-icon>home</v-icon>
            </v-btn>
          </v-flex>
          <v-flex class="text-xs-right">
            <v-btn fab flat dark small class="hidden-sm-and-up" @click="drawer = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <div v-if="selectedBot.unlock_ticket_3" class="px-3 text-xs-center" style="color: white">
          <div style="font-size: 16px">
            {{ $store.state.userid }}
          </div>
        </div>
        <ul class="home-m menu-list"></ul>
        <div v-if="!isTicket2agent" class="text-xs-center">
          <div class="avatar mb-2">
            <div class="avatar-img" style="position: relative">
              <div style="position: absolute; right: -5px; top: -5px">
                <template
                  v-if="
                    !selectedBot.pagerole ||
                    (selectedBot.pagerole && selectedBot.pagerole == 'admin')
                  "
                ></template>
              </div>
              <!-- selectedBot.pageid -->
              <v-avatar size="100px">
                <BotLogoManager :bot="selectedBot">
                  <template #logo="{ pageLogo }">
                    <img
                      class="responsive-img circle"
                      style="min-width: 100%"
                      alt
                      :src="pageLogo"
                      :class="{
                        'bot-active': selectedBot.status,
                        'bot-inactive': !selectedBot.status
                      }"
                      @error="onError"
                    />
                  </template>
                </BotLogoManager>
              </v-avatar>
            </div>
          </div>
          <div style="margin-bottom: 15px">
            <template v-if="['nt'].includes(selectedBot.type)">
              <div v-if="selectedBot.status" class="status active">
                <em class="fas fa-play" />
                <span style="margin-left: 5px">{{ $t('active') }}</span>
              </div>
              <div v-else class="status inactive">
                <em class="fas fa-pause" />
                <span style="margin-left: 5px">{{ $t('inactive') }}</span>
              </div>
            </template>
            <template v-else>
              <router-link :to="'/' + $i18n.locale() + '/setting'">
                <div v-if="selectedBot.status" class="status active">
                  <em class="fas fa-play" />
                  <span style="margin-left: 5px">{{ $t('active') }}</span>
                </div>
                <div v-else class="status inactive">
                  <em class="fas fa-pause" />
                  <span style="margin-left: 5px">{{ $t('inactive') }}</span>
                </div>
              </router-link>
            </template>
          </div>

          <v-menu
            v-if="!$store.state.userid.includes('zwiz')"
            offset-y
            open-on-hover
            offset-overflow
            max-height="200"
          >
            <template #activator="{ on }">
              <v-btn round outline class="select-page-list" dark small v-on="on">
                <div
                  class="text-truncate"
                  style="
                    display: inline-block;
                    word-break: break-all;
                    max-width: 150px;
                    vertical-align: middle;
                  "
                >
                  {{ selectedBot.pagename }}
                </div>
              </v-btn>
            </template>
            <v-list>
              <v-list-tile
                v-for="(item, index) in optionBotlist"
                :key="index"
                @click="selectBot(item)"
              >
                <v-list-tile-title class="primary-color">{{ item.name }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
          <div v-else>
            <v-tooltip bottom>
              <template #activator="{ on }">
                <v-chip outline small disabled class="white--text chip-overflow" v-on="on">
                  {{ selectedBot.pagename }}
                </v-chip>
              </template>
              <span>{{ selectedBot.pagename }}</span>
            </v-tooltip>
          </div>

          <template v-if="selectedBot.pagetype == 'enterprise'">
            <v-chip color="blue-grey darken-1" small>
              <v-icon class="mr-2" small>grade</v-icon>
              {{ $t('Enterprise') }} ({{ selectedBot.expriedDate }} {{ $t('Day(s)') }})
            </v-chip>
          </template>
          <template v-else-if="$store.getters.getPackage == 'premium'">
            <router-link
              :to="'/' + $i18n.locale() + '/upgrade?tab=yourpackage'"
              class="link link-white"
              style="font-size: 18px"
            >
              <v-chip color="info" small>
                <v-icon class="mr-2" small>grade</v-icon>
                {{ $t('Premium remain {num} day(s)', { num: selectedBot.expriedDate }) }}
              </v-chip>
            </router-link>
          </template>
          <template v-else>
            <router-link
              :to="'/' + $i18n.locale() + '/upgrade?tab=package'"
              class="link link-white"
              style="font-size: 18px"
            >
              <v-chip color="indigo lighten-4" small>
                <v-icon class="mr-2" small>lock</v-icon>
                {{ $t('You are using FREE package') }}
              </v-chip>
            </router-link>
          </template>
        </div>
        <div v-else class="px-3 text-xs-right" style="color: white">
          <div style="font-size: 23px">
            {{ $store.state.userid }}
          </div>
          <div>{{ $store.state.privilege.role }}</div>
        </div>
        <div class="mt-1">
          <div>
            <MenuList></MenuList>
          </div>
        </div>
      </v-navigation-drawer>
      <v-content>
        <div style="position: relative" class="thishiw">
          <div v-if="!selectedBot.status" class="alert-header alert-warning" role="alert">
            <v-container fluid>
              <v-layout wrap>
                <v-flex xs2 sm1 class="text-xs-center">
                  <vue-simple-svg
                    :filepath="'/static/img/assets/_global/warning.svg'"
                    width="30px"
                    height="auto"
                    class="icon"
                  />
                </v-flex>
                <v-flex xs8 sm10>
                  <div class="strong">{{ $t('Warning!') }}</div>
                  {{ $t('If you want to test, please activate your bot') }}
                  <a href="javascript:void(0);" @click="toggleBotStatus">
                    {{ $t('Click for starting your Bot') }}
                  </a>
                </v-flex>
              </v-layout>
            </v-container>
          </div>

          <div
            v-if="expriedTime > 0 && expriedDate <= 7 && showAlertExpiredPackage"
            class="alert-header alert-warning"
            role="alert"
          >
            <v-container fluid>
              <v-layout wrap>
                <v-flex xs2 sm1 class="text-xs-center">
                  <vue-simple-svg
                    :filepath="'/static/img/assets/_global/warning.svg'"
                    width="30px"
                    height="auto"
                    class="icon"
                  />
                </v-flex>
                <v-flex xs8 sm10>
                  <div class="strong" style="padding-right: 15px">{{ $t('Warning!') }}</div>
                  {{ $t('Your package will be expired in') }}
                  <template v-if="expriedTime > 0">
                    <countdown :time="expriedTime * 1000">
                      <template slot-scope="props">
                        <template v-if="props.days">
                          {{ props.days }}
                          <span class="small">{{ $t('Days') }}</span>
                        </template>
                        <template v-else-if="props.hours > 0">
                          {{ props.hours }}
                          <span class="small">{{ $t('Hours') }}</span>
                        </template>
                        <template v-else-if="props.minutes > 0">
                          {{ props.minutes }}
                          <span class="small">{{ $t('Minutes') }}</span>
                        </template>
                        <template v-else>
                          {{ props.seconds }}
                          <span class="small">{{ $t('Seconds') }}</span>
                        </template>
                      </template>
                    </countdown>
                    <!-- {{expriedTime}}  -->
                  </template>
                  <router-link
                    v-if="selectedBot.pagetype != 'enterprise'"
                    :to="'/' + $i18n.locale() + '/upgrade'"
                    >{{ $t('click here to extent your package') }}</router-link
                  >
                </v-flex>
                <v-flex xs2 sm1 class="text-xs-right">
                  <v-btn
                    flat
                    fab
                    small
                    dark
                    @click="$store.dispatch('clearAlert', 'expriedPackage')"
                  >
                    <v-icon>close</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </div>

          <div
            v-if="showAlertReplyCommentFlag && !selectedBot.replycommentflag"
            class="alert-header alert-warning"
            role="alert"
          >
            <v-container fluid>
              <v-layout wrap>
                <v-flex xs2 sm1 class="text-xs-center">
                  <vue-simple-svg
                    :filepath="'/static/img/assets/_global/warning.svg'"
                    width="30px"
                    height="auto"
                    class="icon"
                  />
                </v-flex>
                <v-flex xs8 sm10>
                  <div class="strong" style="padding-right: 15px">{{ $t('Warning!') }}</div>
                  ตอบกลับคอมเมนต์ถูกปิดเนื่องจากป้องกันการบล็อคจาก Facebook

                  <router-link :to="'/' + $i18n.locale() + '/billing'">{{
                    $t('คลิกเพื่อเปิดตอบกลับคอมเมนต์')
                  }}</router-link>
                </v-flex>
                <v-flex xs2 sm1 class="text-xs-right">
                  <v-btn
                    flat
                    fab
                    small
                    dark
                    @click="$store.dispatch('clearAlert', 'replyCommentFlag')"
                  >
                    <v-icon>close</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </div>

          <div
            v-if="isPremiumExpired && showAlertExpiredPremium"
            class="alert-header alert-warning grey"
            role="alert"
          >
            <v-container fluid>
              <v-layout wrap>
                <v-flex xs2 sm1 class="text-xs-center">
                  <vue-simple-svg
                    :filepath="'/static/img/assets/_global/warning.svg'"
                    width="30px"
                    height="auto"
                    class="icon"
                  />
                </v-flex>
                <v-flex xs8 sm10>
                  <div class="strong" style="padding-right: 15px">{{ $t('Warning!') }}</div>
                  {{ $t('Your premium package has expired, click here to continue this package') }}
                  <template v-if="expriedTime > 0">
                    <countdown :time="expriedTime * 1000">
                      <template slot-scope="props">
                        <template v-if="props.days">
                          {{ props.days }}
                          <span class="small">{{ $t('Days') }}</span>
                        </template>
                        <template v-else-if="props.hours > 0">
                          {{ props.hours }}
                          <span class="small">{{ $t('Hours') }}</span>
                        </template>
                        <template v-else-if="props.minutes > 0">
                          {{ props.minutes }}
                          <span class="small">{{ $t('Minutes') }}</span>
                        </template>
                        <template v-else>
                          {{ props.seconds }}
                          <span class="small">{{ $t('Seconds') }}</span>
                        </template>
                      </template>
                    </countdown>
                    <!-- {{expriedTime}}  -->
                  </template>
                  <a
                    v-if="selectedBot.pagetype != 'enterprise'"
                    target="_blank"
                    @click="$router.push('Upgrade')"
                    >{{ $t('click here to extent your package') }}</a
                  >
                </v-flex>
                <v-flex xs2 sm1 class="text-xs-right">
                  <v-btn
                    flat
                    fab
                    small
                    dark
                    @click="$store.dispatch('clearAlert', 'expriedPremium')"
                  >
                    <v-icon>close</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </div>
          <div
            v-if="!selectedBot.packages.includes('line') && showAlertLine && false"
            class="alert-header alert-line"
          >
            <v-container fluid>
              <v-layout wrap>
                <v-flex xs2 sm1 class="text-xs-center">
                  <vue-simple-svg
                    :filepath="'/static/img/assets/_global/line.svg'"
                    width="30px"
                    height="auto"
                    class="icon"
                  />
                </v-flex>
                <v-flex xs8 sm10>
                  <div class="strong">{{ $t('Line Chatbot is available!') }}</div>
                  {{ $t('Connect with line now') }}
                  <a href="https://blog.zwiz.ai/tutorial-7-เชื่อม-line/" target="_blank">
                    {{ $t('Read tutorial') }}
                  </a>
                  {{ $t('and') }}
                  <router-link :to="'/' + currentLang + '/setting?go=line'">
                    {{ $t('Go to setup') }}
                  </router-link>
                </v-flex>
                <v-flex xs2 sm1 class="text-xs-right">
                  <v-btn flat fab small dark @click="$store.dispatch('clearAlert', 'line')">
                    <v-icon>close</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </div>
          <div v-if="selectedBot.statustoken === false" class="alert-header alert-warning red">
            <v-container fluid>
              <v-layout wrap>
                <v-flex xs2 sm1 class="text-xs-center">
                  <vue-simple-svg
                    :filepath="'/static/img/assets/_global/warning.svg'"
                    width="30px"
                    height="auto"
                    class="icon"
                  />
                </v-flex>
                <v-flex xs8 sm10>
                  <div class="strong">{{ $t('Hey! Your chatbot has connection error.') }}</div>
                  {{ $t('Admin page please log into the zwiz system') + ' ' + $t('again.') }}
                </v-flex>
                <v-flex xs2 sm1 class="text-xs-right">
                  <v-btn flat fab small dark @click="$store.dispatch('clearAlert', 'line')">
                    <v-icon>close</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </div>

          <!-- <div
              v-if="
                showAds &&
                selectedBot.pagetype != 'enterprise' &&
                ['Upgrade', 'welcome message'].includes($route.name)
              "
            >
              <div @click="clickAds" style="position: relative; cursor: pointer">
                <v-img src="/static/img/banner.jpg"></v-img>
                <v-btn
                  @click.stop="closeAds"
                  depressed
                  icon
                  style="background-color: orange; position: absolute; right: 2px; top: 2px"
                >
                  <v-icon>close</v-icon>
                </v-btn>
              </div>
            </div> -->
        </div>
        <slot></slot>
      </v-content>

      <app-footer />
    </div>
    <!-- <template v-if="$router.history.current.name !== 'allinonechat' || $router.history.current.name !== 'livechat'"> -->
    <template
      v-if="
        $route.name !== 'allinonechat' &&
        $route.name !== 'allinonechat-new' &&
        $route.name !== 'livechat' &&
        $route.name !== 'rabbitreplyfbpost'
      "
    >
      <modal-welcome></modal-welcome>
      <div style="height: 100px"></div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import header from '@/components/elements/header'
import footer from '@/components/elements/footer'
import moment from 'moment'
import ModalWelcome from '@/components/elements/ModalWelcome'
import MenuList from './MenuList/main.vue'
import BotLogoManager from '@/components/elements/BotLogoManager.vue'

import api from '@/api'

export default {
  name: 'MainLayout',
  components: {
    'app-header': header,
    'app-footer': footer,
    ModalWelcome,
    MenuList,
    BotLogoManager
  },

  data: function () {
    return {
      drawer: null,
      showAds: true,
      autostart: false,
      introConfig: {
        nextLabel: this.$t('Next'),
        prevLabel: this.$t('Back'),
        skipLabel: this.$t('skip'),
        doneLabel: this.$t('Finish')
      },
      myOptions: {
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: 'Skip tour',
          buttonPrevious: 'Previous',
          buttonNext: 'Next',
          buttonStop: 'Finish'
        }
      },
      showMenu: false,
      x: 0,
      y: 0,
      currentBot: null,
      pagelist: [],
      selectedOption: {},
      expriedTime: null,
      expriedDate: null,
      navHeight: 0
    }
  },
  computed: {
    showHomeBtn() {
      return this.$localStorage.get('app_type') !== 'warroom'
    },
    toacrmagentmanagement() {
      return (
        ['toacrm'].includes(this.selectedBot.theme) &&
        this.$store.state.privilege.role == 'superadmin'
      )
    },
    mitsuWebchatAgentmanagement() {
      return (
        ['mitsuwebchat'].includes(this.selectedBot.theme) &&
        this.$store.state.privilege.role == 'superadmin'
      )
    },
    ...mapGetters({
      selectedBot: 'selectedBot',
      botlist: 'botlist',
      isSelectedBot: 'isSelectedBot',
      isFacebook: 'isFacebook',
      currentLang: 'currentLang',
      showModalWelcome: 'showModalWelcome'
    }),
    isTicket2agent() {
      if (
        ['ticket2', 'studio7', 'ustore', 'cityfresh'].includes(this.selectedBot.theme) &&
        ['agent', 'superadmin'].includes(this.$store.state.privilege.role)
      ) {
        return true
      } else return false
    },
    pluginMenu() {
      if (this.selectedBot.theme == 'bblcareer') {
        return 'Job Applicants'
      } else if (this.selectedBot.theme == 'grampablokof') {
        return 'Membership'
      } else if (this.selectedBot.theme == 'tero') {
        return 'Questionaire'
      } else if (this.selectedBot.theme == 'toacrm' || this.selectedBot.theme == 'toaecoupon') {
        return 'Reward manager'
      } else if (this.selectedBot.theme == 'plern') {
        return 'Voucher Code'
      } else {
        return 'Plug-In'
      }
    },
    isDefaultTheme() {
      return this.$vuetify.theme.primary == '#FF706B'
    },
    isPremiumExpired() {
      let expire = this.$store.state.selectedBot.expireat
      let today = moment(new Date()).format('YYYY-MM-DDTHH:mm:ss.SSS')
      let register = this.$store.state.selectedBot.registerat
      return expire > register && expire < today
    },
    showUpsell1: function () {
      if (this.$store.getters.showAlert('upsell1') >= 0) {
        var alert = this.$store.getters.showAlert('upsell1')
        return alert.show
      } else {
        return true
      }
    },
    showAlertLine: function () {
      if (this.$store.getters.showAlert('line') >= 0) {
        var alert = this.$store.getters.showAlert('line')
        return alert.show
      } else {
        return true
      }
    },
    showAlertExpiredPackage: function () {
      if (this.$store.getters.showAlert('expriedPackage') >= 0) {
        var alert = this.$store.getters.showAlert('expriedPackage')
        return alert.show
      } else {
        return true
      }
    },
    showAlertReplyCommentFlag: function () {
      if (this.$store.getters.showAlert('replyCommentFlag') >= 0) {
        var alert = this.$store.getters.showAlert('replyCommentFlag')
        return alert.show
      } else {
        return true
      }
    },
    showAlertExpiredPremium: function () {
      if (this.$store.getters.showAlert('expriedPremium') >= 0) {
        var alert = this.$store.getters.showAlert('expriedPremium')
        return alert.show
      } else {
        return true
      }
    },
    optionBotlist: function () {
      // let options = []
      // let vm = this
      // $.each(vm.botlist, function (index, val) {
      //   if (val.pageid != vm.selectedBot.pageid) {
      //     options.push({ name: val.pagename, value: val.pageid })
      //   }
      // })

      return this.botlist
        .map((el) => {
          if (el.pageid == this.selectedBot.pageid) return null
          return { name: el.pagename, value: el.pageid }
        })
        .filter((el) => {
          return el != null
        })
        .sort((a, b) => {
          var nameA = a.name.toUpperCase() // ignore upper and lowercase
          var nameB = b.name.toUpperCase() // ignore upper and lowercase
          if (nameA < nameB) {
            return -1
          }
          if (nameA > nameB) {
            return 1
          }

          // names must be equal
          return 0
        })
    },
    sidebarWidth() {
      return this.drawer ? 300 : 0
    }
  },
  mounted: function () {
    var vm = this

    // console.log('outside')
    // if(vm.$route.query.pageid){
    //   console.log('come')
    //   const bot = this.botlist.find(bot => {
    //     return bot.pageid == vm.$route.query.pageid
    //   })
    //   if(bot){
    //   this.$store.dispatch('selectBot', bot)
    //   }
    // }

    vm.$validator.localize(vm.currentLang)

    var now = moment()
    var expriedDate = moment(this.$store.state.selectedBot.expireat)
    this.expriedDate = parseInt(expriedDate.diff(now, 'days'))
    this.expriedTime = parseInt(expriedDate.diff(now, 'seconds'))

    vm.selectedOption = {
      name: vm.selectedBot.pagename,
      value: vm.selectedBot.pageid
    }
    vm.getSetting(function (contents) {
      vm.$store.dispatch('updateSetting', contents)
    })

    vm.getWelcomeMessage(function (welcomeMessage) {
      vm.$store.dispatch('updateWelcomeMessage', welcomeMessage)
    })

    // this.$tours['myTour'].start()

    if (vm.showModalWelcome) {
      // vm.openTutorial()
    }
  },
  created: function () {
    if (
      localStorage.getItem('hideads') &&
      localStorage.getItem('hideads').includes(this.selectedBot.pageid)
    ) {
      this.showAds = false
    }
  },
  methods: {
    closeAds() {
      var closeads = ''
      if (
        localStorage.getItem('hideads') &&
        !localStorage.getItem('hideads').includes(this.selectedBot.pageid)
      ) {
        closeads = localStorage.getItem('hideads') + ',' + this.selectedBot.pageid
      } else {
        closeads = this.selectedBot.pageid
      }
      localStorage.setItem('hideads', closeads)
      this.showAds = false
    },
    isShowMenu(menu) {
      // welcome
      // conversation
      // comment
      // broadcast
      // template
      // livechat
      // dashboard
      // training
      // billing
      if (this.selectedBot.theme == 'scgdistribution') {
        return !['training'].includes(menu)
      } else if (
        this.$store.state.toacustomerpage.includes(this.selectedBot.pageid) &&
        ['TOAadminliveChat01', 'TOAadminliveChat02'].includes(this.$store.state.userid)
      ) {
        return ['livechat'].includes(menu)
      } else if (this.selectedBot.theme == 'toacrm') {
        if (this.$store.state.privilege && this.$store.state.privilege.role == 'superadmin') {
          return true
        } else {
          return ['template'].includes(menu)
        }
      } else if (
        ['ticket2', 'studio7', 'ustore'].includes(this.selectedBot.theme) ||
        [...this.$store.state.toaPaintPage].includes(this.selectedBot.pageid)
      ) {
        if (this.$store.state.privilege) {
          if (this.$store.state.privilege.role == 'agent') {
            if (this.selectedBot.theme == 'ustore') {
              return ['profile', 'ticketmanagement', 'livechat', 'dashboard'].includes(menu)
            } else {
              return ['profile', 'ticketmanagement', 'livechat'].includes(menu)
            }
          } else if (this.$store.state.privilege.role == 'chatbot') {
            return !['profile', 'ticketmanagement', 'agentmanagement'].includes(menu)
          } else if (this.$store.state.privilege.role == 'superadmin') {
            return [
              'profile',
              'ticketmanagement',
              'livechat',
              'agentmanagement',
              'dashboard'
            ].includes(menu)
          } else if (this.$store.state.privilege.role == 'systemadmin') {
            return true
          }
        } else return ['livechat'].includes(menu)
      } else if (
        this.selectedBot.theme == 'ticket' ||
        this.$store.state.ticketThemeList.includes(this.selectedBot.theme) ||
        this.$store.state.ticketPageid.includes(this.selectedBot.pageid)
      ) {
        if (this.$store.state.privilege && this.$store.state.privilege.agent_management) {
          return true
        } else return ['livechat'].includes(menu)
      } else if (this.selectedBot.type === 'hopinnhr') {
        if (this.$store.state.privilege && this.$store.state.privilege.agent_management) {
          return true
        } else return !['template'].includes(menu)
      } else if (this.selectedBot.type === 'yasale-ac') {
        if (this.$store.state.privilege && this.$store.state.privilege.role === 'superadmin') {
          return true
        } else return ['template'].includes(menu)
      } else if (this.selectedBot.theme == 'toa' && this.selectedBot.pagerole == 'livechat') {
        this.$router.push('livechat')
        return ['livechat'].includes(menu)
      } else if (['101836095321926', '367570166993820'].includes(this.selectedBot.pageid)) {
        if (this.$store.state.privilege && this.$store.state.privilege.mjd_management == true) {
          return true
        } else {
          this.$router.push('template')
          return ['template'].includes(menu)
        }
      } else if (this.$store.state.menubypageid[this.selectedBot.pageid]) {
        return this.$store.state.menubypageid[this.selectedBot.pageid].includes(menu)
      } else return true
    },
    onGoHome() {
      location.href = '/' + this.$i18n.locale() + '/allbots'
    },
    clickAds() {
      // var prefix = window.location.hostname == 'cms.zwiz.ai' ? 'z_' : ''
      // this.$ga.event('event', prefix + 'banner_5999', this.selectedBot.pagename)
      this.$router.push('upgrade')
    },
    ticket2checkstatus() {
      return new Promise((resolve) => {
        api.ticket2checkstatus(
          { adminId: this.$store.state.userid, pageid: this.selectedBot.pageid },
          (err, response) => {
            if (response.status) {
              resolve(true)
            } else {
              resolve(false)
            }
          }
        )
      })
    },
    logout: async function () {
      var vm = this
      var text = vm.$t('Do you want to Logout?')

      if (['studio7', 'ustore', 'ticket2'].includes(vm.selectedBot.theme)) {
        var isCheckout = await this.ticket2checkstatus()
        if (!isCheckout) {
          text = 'หากคุณลงชื่อออก ระบบจะทำการ Checkout ด้วย'
        }
      }

      vm.$swal
        .fire({
          title: text,
          type: 'question',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then(async (result) => {
          if (result.value) {
            if (['studio7', 'ustore', 'ticket2'].inlcudes(vm.selectedBot.theme) && !isCheckout) {
              await vm.ticket2checkincheckout('check-out')
              await vm.$swal.fire({
                type: 'success',
                text: 'ลงชื่อออกและ Checkout สำเร็จ'
              })
            }
            var isFacebook = vm.isFacebook
            vm.$store.dispatch('logout', null).then()
            if (isFacebook) {
              vm.$router.push('/' + vm.currentLang + '/login')
            } else {
              vm.$router.push('/' + vm.currentLang + '/nigol')
            }
          }
        })
    },
    ticket2checkincheckout(actions) {
      return new Promise((resolve) => {
        var data = {
          adminId: this.$store.state.userid,
          pageid: this.selectedBot.pageid,
          actions // check-in หรือ check-out
        }
        api.ticket2checkincheckout(data, (err, response) => {
          if (response.responsecode == 200) {
            resolve()
          }
        })
      })
    },
    selectBot: function (page) {
      var vm = this
      vm.$store.dispatch('loading')
      if (vm.botlist) {
        vm.botlist.forEach((bot) => {
          if (page.value === bot.pageid) {
            vm.$store.dispatch('selectBot', bot)
          }
        })
      }
      location.reload()
    },
    onError: function (event) {
      // eslint-disable-next-line no-undef
      $(event.target).attr('src', '/static/img/assets/livechat/profile.png')
    },
    show(e) {
      e.preventDefault()
      this.showMenu = false
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.showMenu = true
      })
    },
    getSetting: function (callback) {
      let vm = this
      var data = {
        pageid: vm.$store.state.selectedBot.pageid
      }

      api.getSetting(data, function (error, response) {
        if (error) {
          console.error(error)
          return
        }

        var contents = {}
        try {
          response.data.forEach((el) => {
            contents[el.contenttype] = el
          })
        } catch (error) {
          console.error(error)
        }

        callback(contents)
      })
    },
    getWelcomeMessage: function (callback) {
      let vm = this
      // vm.$store.dispatch('loading')
      let data = {
        pageid: vm.selectedBot.pageid
      }

      var message = null
      var generics = [
        {
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: true
        }
      ]
      var messages = null
      var type = 'json'
      api.getWelcomeMessage(data, function (error, response) {
        if (error) {
          console.error(error)
          return
        }
        if (response.data) {
          type = response.data.type
          if (type === 'message') {
            messages = [
              [
                {
                  text: response.data.message_text,
                  type: 'text'
                }
              ]
            ]
          } else if (type === 'generic') {
            messages = [[]]
            if (
              response.data.message &&
              typeof response.data.message === 'object' &&
              response.data.message.length > 0
            ) {
              response.data.message.forEach((val, index) => {
                generics[index] = val
              })

              messages[0][0] = {
                type: 'generic',
                data: generics,
                ratio: response.data.ratio == 'horizontal' ? 'horizontal' : 'square'
              }
            }
          } else {
            if (vm.isJsonParseable(response.data.message)) {
              messages = JSON.parse(response.data.message)
            }
          }
          type = 'json'
        }
        callback({
          type: type,
          message: message,
          generics: generics,
          messages: messages
        })
      })
    },
    toggleBotStatus: async function () {
      let bot = Object.assign({}, this.selectedBot)
      bot.status = !bot.status
      this.$store.dispatch('loading')
      await this.$store.dispatch('toggleBotStatus', bot)
      this.botStatus = bot.status
      this.$store.dispatch('loading')
    },
    handleHeaderResize({ contentRect }) {
      this.navHeight = contentRect.height
    }
  }
}
</script>

<style lang="scss">
.menu.default {
  background-color: #ff846d !important;
}
.menu {
  .avatar {
    .bot-active {
      border: 3px solid #a0e83d;
    }

    .bot-inactive {
      border: 3px solid red;
    }
  }

  ul.menu-list {
    list-style: none;
    padding: 0.5em 0;
    margin: 0;

    .router-link-active {
      li {
        background-color: rgba(255, 255, 255, 0.2);
      }
    }

    a {
      text-decoration: none;
    }
    li {
      font-size: 0.95em;
      font-weight: 300;
      background-repeat: no-repeat;
      background-position: left 15px center;
      background-size: auto 20px;
      transition: all 0.15s linear;
      padding: 1em 1em 1em 3em;
      cursor: pointer;

      &.icon-home {
        background-image: url('/static/img/assets/sidebar/home.svg');
      }

      &.icon-greeting {
        background-image: url('/static/img/assets/sidebar/greeting.svg');
      }

      &.icon-speech {
        background-image: url('/static/img/assets/sidebar/speech.svg');
      }

      &.icon-mailbox {
        background-image: url('/static/img/assets/sidebar/mailbox.svg');
      }

      &.icon-analytics {
        background-image: url('/static/img/assets/sidebar/analytics.svg');
      }

      &.icon-billing {
        background-image: url('/static/img/assets/sidebar/billing.svg');
      }

      &.icon-setting {
        background-image: url('/static/img/assets/sidebar/setting.svg');
      }
      &.icon-ticket {
        background-image: url('/static/img/assets/sidebar/ticket.svg');
      }

      &.icon-gym {
        background-image: url('/static/img/assets/sidebar/gym.svg');
      }

      &.icon-help {
        background-image: url('/static/img/assets/sidebar/help.svg');
      }

      &.icon-megaphone {
        background-image: url('/static/img/assets/sidebar/megaphone.svg');
      }
      &.icon-reward {
        background-image: url('/static/img/assets/sidebar/reward.svg');
      }

      &.icon-premium {
        background-image: url('/static/img/assets/sidebar/premium.svg');
      }

      &.icon-shop {
        background-image: url('/static/img/assets/sidebar/shop.svg');
      }

      &.icon-sign-out {
        background-image: url('/static/img/assets/sidebar/sign-out.svg');
      }

      &.icon-plugin {
        background-image: url('/static/img/assets/sidebar/plugin.svg');
      }
      &.icon-live {
        background-image: url('/static/img/assets/sidebar/live.svg');
      }
      &.icon-ticket {
        background-image: url('/static/img/assets/sidebar/technical-support.svg');
      }

      span {
        width: 100%;
        color: white;
        margin-left: 10px;
      }

      &:hover {
        background-color: rgba(0, 0, 0, 0.1);
      }
    }

    .devide {
      border-bottom: 1px solid #ff8c88;
    }
  }
}
h1,
h2,
h3,
h4,
h5,
h6 {
  color: var(--primary-color);
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/Main.vue